import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import imageCompression from 'browser-image-compression';
import { ENTITY_TYPES } from "../../../utils/constants";
// Initialize toast
export const showToast = (message, type = 'info') => {
  toast[type](message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};


export function base64ToFile(base64, filename) {
  if (typeof base64 !== 'string' || !base64.includes(',')) {
    return null;
  }

  const [header, data] = base64.split(',');
  const mimeMatch = header.match(/:(.*?);/);
  const mime = mimeMatch?.[1] || 'application/octet-stream';
  
  try {
    const binaryString = atob(data || '');
    const bytes = new Uint8Array(binaryString.length);
    
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return new File([bytes], filename || 'file', { type: mime });
  } catch {
    const blob = new Blob([], { type: mime });
    blob.name = filename || 'file';
    return blob;
  }
}




/**
 * Compresses an image file using browser-image-compression.
 *
 * @param {File} file - The image file to compress.
 * @param {Object} [options={}] - Optional compression options.
 * @returns {Promise<File>} - The compressed image file.
 */
export default async function compressImage(file, options = { maxSizeMB: 0.1,
  maxWidthOrHeight: 1024}) {
  const defaultOptions = {
    maxSizeMB: 0.5,             // Maximum size in MB
    maxWidthOrHeight: 1920,   // Max width or height
    useWebWorker: true,       // Use multi-threading for performance
  };

  const compressionOptions = { ...defaultOptions, ...options };

  try {
    const compressedFile = await imageCompression(file, compressionOptions);
    return compressedFile;
  } catch (error) {
    console.error('Error while compressing image:', error);
    return file; // Return original file if compression fails
  }
}

const today = new Date();

  // Calculate "Today"
  const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  // Calculate "Yesterday"
  const yesterday = new Date(todayDate);
  yesterday.setDate(todayDate.getDate() - 1);

  // Calculate "This Week"
  const thisWeekStart = new Date(todayDate);
  thisWeekStart.setDate(todayDate.getDate() - todayDate.getDay() + 1); // Start from Monday

  // Calculate "Last Week"
  const lastWeekEnd = new Date(thisWeekStart);
  lastWeekEnd.setDate(thisWeekStart.getDate() - 1); // Last week's end is the day before this week's start
  const lastWeekStart = new Date(lastWeekEnd);
  lastWeekStart.setDate(lastWeekEnd.getDate() - 6);

  // Calculate "This Month"
  const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);

  // Calculate "Last Month"
  const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month

  // Calculate "Last 30 Days"
  const last30DaysStart = new Date(todayDate);
  last30DaysStart.setDate(todayDate.getDate() - 30);

  // Calculate "Today Last Year"
  const todayLastYear = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());

  // Define Ranges
  export const definedRanges = [
    {
      label: "Today",
      startDate: todayDate,
      endDate: todayDate,
    },
    {
      label: "Yesterday",
      startDate: yesterday,
      endDate: yesterday,
    },
    {
      label: "This Week",
      startDate: thisWeekStart,
      endDate: todayDate,
    },
    {
      label: "Last Week",
      startDate: lastWeekStart,
      endDate: lastWeekEnd,
    },
    {
      label: "This Month",
      startDate: thisMonthStart,
      endDate: todayDate,
    },
    {
      label: "Last 30 Days",
      startDate: last30DaysStart,
      endDate: todayDate,
    },
    {
      label: "Last Month",
      startDate: lastMonthStart,
      endDate: lastMonthEnd,
    },
    {
      label: "Today Last Year",
      startDate: todayLastYear,
      endDate: todayDate,
    },
  ];

  export function formatToISODateTime(inputDate, dateType) {
  const date = new Date(inputDate);
  const pad = (n) => String(n).padStart(2, '0');

  let hours, minutes, seconds;

  if (dateType === 'startDate') {
    hours = 0;
    minutes = 0;
    seconds = 0;
  } else if (dateType === 'endDate') {
    hours = 23;
    minutes = 59;
    seconds = 59;
  } else {
    hours = date.getHours();
    minutes = date.getMinutes();
    seconds = date.getSeconds();
  }

  return (
    date.getFullYear() + "-" +
    pad(date.getMonth() + 1) + "-" +
    pad(date.getDate()) + "T" +
    pad(hours) + ":" +
    pad(minutes) + ":" +
    pad(seconds)
  );
}

export const convertAndSetFile = (fileData) => {
  if (!fileData) return null;
  
  if (Array.isArray(fileData)) {
    return convertAndSetFile(fileData[0]);
  }
  
  if (fileData?.base64?.includes(',') && fileData?.filename) {
    return base64ToFile(fileData.base64, fileData.filename);
  }
  if (fileData?.remote && (fileData?.url || fileData?.documentPath)) {
    return fileData;
  }  
  return null;
};

export const handleOpenPrivacyPolicy = () => {
  window.open("/privacy-policy", "_blank", "noopener,noreferrer");
};

export const handleOpenTermsOfService = () => {
  window.open("/terms-of-service", "_blank", "noopener,noreferrer");
};

export const handleOpenContactUs = () => {
  window.open("/contact-us", "_blank", "noopener,noreferrer");
};

export const TOKEN_KEYS = {
  JWT: 'jwtToken',
  BUSINESS_TYPE: 'userBusinessType',
  ENTITY_TYPE: 'userEntityType',
  USER_INFO: 'user',
  SESSION_TIMEOUT: 'sessionTimeoutId',
  USER_TYPE: 'userType',
  BORROWER_TYPE: 'borrowerType',
};

  export const getFinancialYear = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 1-based month
    if (month >= 4) {
      return `${year}-${year + 1}`;
    } else {
      return `${year - 1}-${year}`;
    }
  };

  export const getEntityTypeLabel = (entityType) => {
    if (!entityType) return `Non Company`;

    switch (entityType.toLowerCase()) {
      case ENTITY_TYPES.COMPANY.toLowerCase():
        return "Company";
      case ENTITY_TYPES.PARTNERSHIP_FIRM.toLowerCase():
        return "Partnership Firm";
      case ENTITY_TYPES.PROPRIETORSHIP_FIRM.toLowerCase():
        return "Proprietorship Firm";
      default:
        return entityType;
    }
  };

